import React from "react";

function Visa() {
  return (
    <div className="home">
      <iframe
        title="Visa"
        class="video"
        widht="100%"
        height="100%"
        src="https://app.powerbi.com/reportEmbed?reportId=251cd387-bb5d-44ee-bd3b-783ad5409380&autoAuth=true&ctid=f88c7305-11d1-4b34-a8a0-da6536019e31"
        marginheight="0"
        marginwidth="0"
        scrolling="0"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default Visa;
